const XlsxDownloadHook = {
  mounted() {
    this.handleEvent("download_xlsx", ({ binary, filename }) => {
      const bytes = Uint8Array.from(atob(binary), c => c.charCodeAt(0));
      const blob = new Blob([bytes], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);
    });
  }
};

export default XlsxDownloadHook;